import React, { useState } from "react";
import PropTypes from "prop-types";
import { Popconfirm as AntPopconfirm } from "antd";
import Icon from "../Icon";
import { UiButton } from "./Button.style";
/**
 * 按鈕組件
 */

const Button = ({
  variant = "orange",
  size,
  children,
  disabled,
  loading,
  mr,
  onClick,
  full = true
}) => {
  return /*#__PURE__*/React.createElement(UiButton, {
    variant: variant,
    block: true,
    size: size,
    onClick: onClick,
    disabled: disabled,
    loading: loading,
    mr: mr,
    full: full ? 1 : 0
  }, children);
};

export const IconButton = ({
  variant = "orange",
  size,
  children,
  disabled,
  loading,
  mr,
  onClick,
  full = true,
  iconName = "close",
  icon,
  type = "default"
}) => {
  return /*#__PURE__*/React.createElement(UiButton, {
    variant: variant,
    block: true,
    size: size,
    onClick: onClick,
    disabled: disabled,
    loading: loading,
    mr: mr,
    full: full ? 1 : 0
  }, /*#__PURE__*/React.createElement("div", {
    className: "icon"
  }, icon ? icon : /*#__PURE__*/React.createElement(Icon, {
    name: iconName,
    type: type
  })), children);
};
export const Popconfirm = ({
  title = "",
  variant = "orange",
  size,
  children,
  disabled,
  loading,
  full = true,
  mr,
  onConfirm = () => {}
}) => {
  const [deletePopup, setDeletePopup] = useState(false);

  const onConfirmHandle = () => {
    setDeletePopup(false);
    onConfirm();
  };

  return /*#__PURE__*/React.createElement(AntPopconfirm, {
    title: title,
    visible: deletePopup,
    onConfirm: onConfirmHandle,
    onCancel: () => setDeletePopup(false),
    okText: "\u78BA\u5B9A",
    cancelText: "\u53D6\u6D88"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: variant,
    block: true,
    size: size,
    onClick: () => setDeletePopup(true),
    disabled: disabled,
    loading: loading,
    mr: mr,
    full: full
  }, children));
};
export default Button;
Button.propTypes = {
  variant: PropTypes.string,
  size: PropTypes.string,
  children: PropTypes.node,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  mr: PropTypes.number,
  full: PropTypes.bool
};
IconButton.propTypes = {
  variant: PropTypes.string,
  size: PropTypes.string,
  children: PropTypes.node,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  mr: PropTypes.number,
  full: PropTypes.bool,
  iconName: PropTypes.string,
  type: PropTypes.string,
  icon: PropTypes.node
};
Popconfirm.propTypes = {
  title: PropTypes.string,
  variant: PropTypes.string,
  size: PropTypes.string,
  children: PropTypes.node,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  full: PropTypes.bool,
  visible: PropTypes.bool,
  mr: PropTypes.number,
  onConfirm: PropTypes.func
};